import { visoStore } from './store';

export async function getSessionDetail(sessionId) {
	const formData = new FormData();
	formData.append('action', 'wpcore_get_session_detail');
	formData.append('nonce', wpcore.nonce);
	formData.append('session_id', sessionId);

	const response = await fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData,
	});

	const json = await response.json();

	if (json.success) {
		visoStore.setCurrentSession(json.data);
		return json.data;
	}

	return null;
}

export async function updateSessionLink(sessionId, link) {
	const formData = new FormData();
	formData.append('action', 'wpcore_update_session_link');
	formData.append('nonce', wpcore.nonce);
	formData.append('session_id', sessionId);
	formData.append('link', link);

	const response = await fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData,
	});

	const json = await response.json();

	if (json.success) {
		const currentSession = visoStore.getCurrentSession();
		if (currentSession) {
			visoStore.setCurrentSession({ ...currentSession, join_url: link });
		}
		return { success: true };
	}

	return { success: false, message: json.data?.message || wpcore.direct_t({ en: 'Failed to save link.', fr: 'Échec de l\'enregistrement du lien.' }) };
}

export async function updateCoachNotes(sessionId, coachNotes) {
	const formData = new FormData();
	formData.append('action', 'wpcore_update_coach_notes');
	formData.append('nonce', wpcore.nonce);
	formData.append('session_id', sessionId);
	formData.append('coach_notes', coachNotes);

	const response = await fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData,
	});

	const json = await response.json();

	if (json.success) {
		const currentSession = visoStore.getCurrentSession();
		if (currentSession) {
			visoStore.setCurrentSession({ ...currentSession, notes: coachNotes });
		}
		return { success: true };
	}

	return { success: false, message: json.data?.message || wpcore.direct_t({ en: 'Failed to send note.', fr: 'Échec de l\'envoi de la note.' }) };
}

export async function cancelSession(sessionId) {
	const formData = new FormData();
	formData.append('action', 'wpcore_cancel_session');
	formData.append('nonce', wpcore.nonce);
	formData.append('session_id', sessionId);

	const response = await fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData,
	});

	const json = await response.json();

	if (json.success) {
		return { success: true };
	}

	return { success: false, message: json.data || wpcore.direct_t({ en: 'Failed to cancel session.', fr: 'Échec de l\'annulation de la session.' }) };
}
